import { useMemo } from 'react'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { DashboardWidget } from 'features/widget/types'
import { WidgetId } from 'features/types'
import { getIndexValue } from './utils'
import { IndexWidgetsType } from '../types'

const getIndexWidgetData = (
  widgetData: DashboardWidget<InsightCount>,
  widgetSetting: IndexWidgetsType
) => {
  const resultData = widgetData.data![0]!.results![0]!.data

  const insightSet =
    resultData!.insights![0]!.dataset![0].set?.filter(
      (item) => item.value! > widgetSetting.minCount!
    ) ?? []
  const insightStatus = resultData!.insights![0]!.dataset![0].status

  const { totalCount, maxIndex } = insightSet.reduce(
    (acc, insight) => ({
      ...acc,
      totalCount: acc.totalCount + insight.value!,
      maxIndex: Math.max(getIndexValue(insight.index!), acc.maxIndex)
    }),
    {
      totalCount: 0,
      maxIndex: 0
    }
  )

  return {
    status: insightStatus,
    insights: insightSet,
    totalCount,
    isEmpty: !insightSet.length || totalCount === 0,
    maxIndex
  }
}

const useIndexWidgetData = (widgetId: WidgetId) => {
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const widgetSetting = useDashboardWidgetSetting<IndexWidgetsType>(widgetId)
  const indexWidgetData = useMemo(() => getIndexWidgetData(widgetData, widgetSetting), [
    widgetData,
    widgetSetting
  ])

  return indexWidgetData
}

export default useIndexWidgetData
